import React from 'react';
import { Language, translations } from '../utils/translations';
export function PricingPanel({
  lang
}: {
  lang: Language;
}) {
  const t = translations[lang];
  return <section aria-labelledby="pricing-title" data-id="element-148" data-mp="2l7wzvstazdpi">
      <h2 id="pricing-title" className="mb-5 text-center text-[19px] font-bold tracking-[-0.03em] text-zinc-50" data-id="element-149" data-mp="2gbgeh6dhndg4">
        {t.pricingTitle}
      </h2>

      <ul className="grid gap-3" data-id="element-150" data-mp="38zlz7t4jl2fy">
        <li className="flex items-center gap-3.5 rounded-2xl bg-zinc-900 p-4" data-id="element-151" data-mp="38yu4slmolar9">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-zinc-800" aria-hidden="true" data-id="element-152" data-mp="341aqjlpzgxzb">
            <img src="https://em-content.zobj.net/source/apple/391/scissors_2702-fe0f.png" alt="Scissors" className="h-6 w-6 object-contain" data-id="element-153" data-mp="2yzbl86aonqzq" />
          </span>
          <div className="flex flex-col" data-id="element-154" data-mp="1nm9fk6a4gluc">
            <span className="text-[15px] font-bold text-zinc-100" data-id="element-155" data-mp="1nnasyhem1kf8">
              {t.price1Title}
            </span>
            <span className="mt-0.5 text-[14px] font-bold text-gold-500" data-id="element-156" data-mp="1ip9a9xl3jn4a">
              {t.price1Value}
            </span>
          </div>
        </li>
        <li className="flex items-center gap-3.5 rounded-2xl bg-zinc-900 p-4" data-id="element-157" data-mp="g8xj5e77tdst">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-zinc-800" aria-hidden="true" data-id="element-158" data-mp="1d7t94ywsgit">
            <img src="https://em-content.zobj.net/source/apple/391/artist-palette_1f3a8.png" alt="Palette" className="h-6 w-6 object-contain" data-id="element-159" data-mp="6ahpb3gszqfm" />
          </span>
          <div className="flex flex-col" data-id="element-160" data-mp="3tg8nrgih0vdf">
            <span className="text-[15px] font-bold text-zinc-100" data-id="element-161" data-mp="3thaaii8un6az">
              {t.price2Title}
            </span>
            <span className="mt-0.5 text-[14px] font-bold text-gold-500" data-id="element-162" data-mp="3etfiz56kv7zh">
              {t.price2Value}
            </span>
          </div>
        </li>
        <li className="flex items-center gap-3.5 rounded-2xl bg-zinc-900 p-4" data-id="element-163" data-mp="35qecv4hppgvt">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-zinc-800" aria-hidden="true" data-id="element-164" data-mp="39si00qdqu9wx">
            <img src="https://em-content.zobj.net/source/apple/391/fire_1f525.png" alt="Fire" className="h-6 w-6 object-contain" data-id="element-165" data-mp="1gaal6c7fykqo" />
          </span>
          <div className="flex flex-col" data-id="element-166" data-mp="1bhrbvrfsebro">
            <span className="text-[15px] font-bold text-zinc-100" data-id="element-167" data-mp="16jg19eho3x8e">
              {t.price3Title}
            </span>
            <span className="mt-0.5 text-[14px] font-bold text-gold-500" data-id="element-168" data-mp="11lo1jyas76tn">
              {t.price3Value}
            </span>
          </div>
        </li>
      </ul>
    </section>;
}